export const INSURANCE_TYPES = {
  CAR: 'car',
  HOME: 'home',
  INCOME_PROTECTION: 'income-protection',
  LIFE: 'life',
  PET: 'pet',
  TRAVEL: 'travel',
} as const;

export const INSURANCE_TYPES_WITH_HEALTH = {
  ...INSURANCE_TYPES,
  HEALTH: 'health',
} as const;

export const INSURANCE_SUB_TYPES = {
  BALI: 'bali',
  NEW_ZEALAND: 'new-zealand',
} as const;

export const COVERAGE_INCLUSION = {
  EXCLUDED: 'excluded',
  INCLUDED: 'included',
  OPTIONAL: 'optional',
};

export const PRODUCT_REVIEW_IDS = {
  car: 'car',
  home: 'home-and-contents',
  travel: 'travel',
} as const;

export const TRAVEL_PRODUCT_TYPES = {
  DOMESTIC: 'domestic',
  INTERNATIONAL: 'international',
};
